<template>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <base-list-management ref="baseListManagement" :configData="configData"></base-list-management>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import configData from './config'
import moment from 'moment'

export default {
  name: 'chargeRecordList',
  data() {
    return {
      configData: configData.call(this),
    }
  },
  mounted() {
    this.$refs.baseListManagement.setItemData({
      elConfigKey: 'value',
      key: 'gmtCreateTime',
      data: [
        moment('00', 'hh').subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
        moment('23:59:59', 'hh:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
      ],
    })
  },
}
</script>
